import { render, staticRenderFns } from "./companyInformation.vue?vue&type=template&id=4061d9b8&scoped=true"
import script from "./companyInformation.vue?vue&type=script&lang=js"
export * from "./companyInformation.vue?vue&type=script&lang=js"
import style0 from "./companyInformation.vue?vue&type=style&index=0&id=4061d9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061d9b8",
  null
  
)

export default component.exports